"use client";
import { useClientTranslation } from "@/app/i18n/client";

export default function SiteMapHeader({urlCount}: {urlCount: number}) {
  const { t: tMaster } = useClientTranslation("tr", "master");

  return (
    <>
      <div className="flex md:flex-row flex-col gap-6 flex-wrap items-start md:items-center    w-full justify-between py-6">
        <div>
          <h1 className="text-primary font-bold text-[32px]">
            {tMaster("content-sitemap-title", {
              defaultValue: "Site Haritası",
            })}
          </h1>

          <span className="text-assistant text-sm">Toplamda {urlCount} adet link bulunmaktadır.</span>
        </div>

        <div className="p-2 bg-gray rounded-full">
          <div className="px-4 py-2 bg-white cursor-pointer text-primary font-bold rounded-full">
            {tMaster("content-sitemap-title", {
              defaultValue: "Site Haritası",
            })}
          </div>
        </div>
      </div>

      <div className="absolute left-0 w-full h-[1px] bg-gray-secondary" />
    </>
  );
}
